import type { PresetTemplate } from './types';

export const PRESET_TEMPLATES: PresetTemplate[] = [
  {
    id: 'weld-score-signature',
    name: 'Weld & Score Signature',
    description: 'Overlapping cursive words with preserved inner score lines and dot bridges.',
    category: 'quote',
    lines: [
      {
        text: 'Always & Forever',
        fontId: 'pacifico',
        fontSizeMm: 45,
        letterSpacingPercent: -5,
        alignment: 'center',
      },
    ],
    weldScoreConfig: {
      weldEnabled: true,
      scoreEnabled: true,
      connectDots: true,
      bridgeWidthMm: 1.6,
      cutColor: '#FF0000',
      scoreColor: '#0055FF',
    },
    backerConfig: {
      type: 'outset',
      offsetMm: 4.5,
      cornerJoin: 'round',
      scoreGuidesOnBacker: true,
      hangerHoles: false,
    },
    material: 'wood-birch',
  },
  {
    id: 'inspiring-quote',
    name: 'Multi-Font Quote Sign',
    description: 'Clean modern sans paired with graceful flowing cursive script.',
    category: 'quote',
    lines: [
      {
        text: 'NEVER STOP',
        fontId: 'montserrat',
        fontSizeMm: 20,
        letterSpacingPercent: 6,
        alignment: 'center',
      },
      {
        text: 'Dreaming Big',
        fontId: 'great-vibes',
        fontSizeMm: 48,
        letterSpacingPercent: -4,
        alignment: 'center',
      },
      {
        text: 'EVERY SINGLE DAY',
        fontId: 'montserrat',
        fontSizeMm: 16,
        letterSpacingPercent: 8,
        alignment: 'center',
      },
    ],
    weldScoreConfig: {
      weldEnabled: true,
      scoreEnabled: true,
      connectDots: true,
      bridgeWidthMm: 1.5,
    },
    backerConfig: {
      type: 'outset',
      offsetMm: 5.0,
      cornerJoin: 'round',
      scoreGuidesOnBacker: true,
      hangerHoles: true,
      hangerHoleCount: 2,
      hangerHoleDiameterMm: 4.0,
      hangerHoleInsetMm: 6.0,
    },
    material: 'wood-walnut',
  },
  {
    id: 'wedding-sign',
    name: 'Family Surname Plaque',
    description: 'Classic serif typography combined with lively connected cursive.',
    category: 'wedding',
    lines: [
      {
        text: 'THE',
        fontId: 'cinzel',
        fontSizeMm: 16,
        letterSpacingPercent: 10,
        alignment: 'center',
      },
      {
        text: 'Patolia Family',
        fontId: 'dancing-script',
        fontSizeMm: 44,
        letterSpacingPercent: -4,
        alignment: 'center',
      },
      {
        text: 'ESTABLISHED 2026',
        fontId: 'cinzel',
        fontSizeMm: 14,
        letterSpacingPercent: 8,
        alignment: 'center',
      },
    ],
    weldScoreConfig: {
      weldEnabled: true,
      scoreEnabled: true,
      connectDots: true,
      bridgeWidthMm: 1.6,
    },
    backerConfig: {
      type: 'frame-oval',
      offsetMm: 6.0,
      cornerJoin: 'round',
      scoreGuidesOnBacker: false,
      hangerHoles: true,
      hangerHoleCount: 1,
      hangerHoleDiameterMm: 4.0,
      hangerHoleInsetMm: 5.0,
    },
    material: 'acrylic-gold',
  },
  {
    id: 'cake-topper',
    name: 'Celebration Cake Topper',
    description:
      'Welded text design with integrated central stake for cakes and floral arrangements.',
    category: 'cake-topper',
    lines: [
      {
        text: 'Happy',
        fontId: 'sacramento',
        fontSizeMm: 36,
        letterSpacingPercent: -5,
        alignment: 'center',
      },
      {
        text: 'Birthday',
        fontId: 'sacramento',
        fontSizeMm: 42,
        letterSpacingPercent: -5,
        alignment: 'center',
      },
    ],
    weldScoreConfig: {
      weldEnabled: true,
      scoreEnabled: true,
      connectDots: true,
      bridgeWidthMm: 1.8,
    },
    backerConfig: {
      type: 'cake-topper',
      offsetMm: 0,
      cornerJoin: 'round',
      scoreGuidesOnBacker: false,
      hangerHoles: false,
      cakeTopperProngLengthMm: 65,
      cakeTopperProngWidthMm: 6.5,
    },
    material: 'acrylic-gold',
  },
  {
    id: 'freestanding-desk-sign',
    name: 'Freestanding Desk Sign',
    description: 'Quote welded onto a bottom support bar with desk stand slot.',
    category: 'sign',
    lines: [
      {
        text: 'Create',
        fontId: 'satisfy',
        fontSizeMm: 40,
        letterSpacingPercent: -4,
        alignment: 'center',
      },
      {
        text: 'SOMETHING TODAY',
        fontId: 'bebas-neue',
        fontSizeMm: 22,
        letterSpacingPercent: 4,
        alignment: 'center',
      },
    ],
    weldScoreConfig: {
      weldEnabled: true,
      scoreEnabled: true,
      connectDots: true,
      bridgeWidthMm: 1.5,
    },
    backerConfig: {
      type: 'base-bar',
      offsetMm: 0,
      cornerJoin: 'round',
      scoreGuidesOnBacker: false,
      hangerHoles: false,
      baseBarHeightMm: 14,
      baseBarExtendMm: 10,
    },
    material: 'wood-birch',
  },
];
